import _ from "underscore";
import axios from "axios";
import sjcl from "sjcl";
import moment from "moment";

const Key: any = process.env.REACT_APP_CIPHER_KEY;

export const transferPhaseData = [
  { phaseName: "Amount", id: 1, pathName: "/remittance" },
  { phaseName: "Remitter", id: 2, pathName: "/remitter" },
  { phaseName: "Recipient", id: 3, pathName: "/pick-recipient" },
  { phaseName: "Documents", id: 4, pathName: "/documents" },
  { phaseName: "Review", id: 5, pathName: "/review" },
  { phaseName: "Payment", id: 6, pathName: "/payment" },
];

export const offlineTransferPhaseData1 = [
  { phaseName: "Amount", id: 1, pathName: "/1/remittance" },
  { phaseName: "Remitter", id: 2, pathName: "/1/remitter" },
  { phaseName: "Recipient", id: 3, pathName: "/1/pick-recipient" },
  { phaseName: "Documents", id: 4, pathName: "/1/documents" },
  { phaseName: "Review", id: 5, pathName: "/1/review" },
];

export const offlineTransferPhaseData2 = [
  { phaseName: "Amount", id: 1, pathName: "/2/remittance" },
  { phaseName: "Remitter Details", id: 2, pathName: "/2/remitter" },
  { phaseName: "Student Details", id: 3, pathName: "/2/documents" },
];

export const offlineTransferPhaseData3 = [
  { phaseName: "Amount", id: 1, pathName: "/3/remittance" },
  { phaseName: "Remitter Details", id: 2, pathName: "/3/remitter" },
  { phaseName: "Student Details", id: 3, pathName: "/3/documents" },
];

export const getActiveStepNumber = (currentRouter: string, activeStepNumber: number) => {
  switch (currentRouter) {
    case "/remittance":
      return 1;
    case "/remitter":
      return 2;
    case "/pick-recipient":
      return 3;
    case "/documents":
      return 4;
    case "/review":
      return 5;
    case "/payment":
      return 6;
    default:
      return activeStepNumber;
  }
};
export const getOfflineActiveStepNumber1 = (currentRouter: string, activeStepNumber: number) => {
  switch (currentRouter) {
    case "/1/remittance":
      return 1;
    case "/1/remitter":
      return 2;
    // case "/1/purpose-code":
    //   return 3;
    case "/1/pick-recipient":
      return 3;
    case "/1/documents":
      return 4;
    case "/1/review":
      return 5;
    default:
      return activeStepNumber;
  }
};
export const getOfflineActiveStepNumber2 = (currentRouter: string, activeStepNumber: number) => {
  switch (currentRouter) {
    case "/2/remittance":
      return 1;
    case "/2/remitter":
      return 2;
    case "/2/documents":
      return 3;
    default:
      return activeStepNumber;
  }
};
export const getOfflineActiveStepNumber3 = (currentRouter: string, activeStepNumber: number) => {
  switch (currentRouter) {
    case "/3/remittance":
      return 1;
    case "/3/remitter":
      return 2;
    case "/3/documents":
      return 3;
    default:
      return activeStepNumber;
  }
};

// regex for Email Address input field
export const regexForEmailAddress =
  // eslint-disable-next-line no-useless-escape, no-control-regex
  /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

// regex for Email Address input field
export const regexForMobileNumber = /^[0-9]{10}$/;

/* Regex for strong password Explanation:
^                 # start-of-string
(?=.*[0-9])       # a digit must occur at least once
(?=.*[a-z])       # a lower case letter must occur at least once
(?=.*[A-Z])       # an upper case letter must occur at least once
(?=.*[@#$%^&+=])  # a special character must occur at least once
(?=\S+$)          # no whitespace allowed in the entire string
.{8,}             # anything, at least eight places though
$                 # end-of-string */
export const regexForPassword = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=\S+$).{8,}$/;

export const regexForName = /^[a-zA-Z ]{2,30}$/;

export const regexForExcludeSpecialCharacter =
  /^(?![a-zA-Z._])(?!.*[a-zA-Z._]$)(?!.*\d_)(?!.*_\d)[0-9_]+$/;

export const regexForSpecialChar = /^[a-zA-Z0-9 ]{1,}$/;

/* Global Errors state Utils */
export const getErrorMessage = (
  errors: { [ref: string]: { type: any } },
  fieldName: string,
  fieldLabel: string
) => {
  if (errors[fieldName]) {
    const { type } = errors[fieldName];
    switch (type) {
      case "required":
        return `${fieldLabel} is required`;
      case "sameAs":
        return "Passwords does not match. Please try again.";
      case "pattern":
        return `Please enter a valid ${fieldLabel}`;
      case "maxLength":
        return `Please Enter valid digit ${fieldLabel}`;
      case "minLength":
        return `Please Enter At least valid digit ${fieldLabel}`;
      default:
        return type;
    }
  } else {
    return false;
  }
};

export const debounce = <T extends (...args: any[]) => void>(func: T, delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const downloadDocumentHistory = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(blob);

  // Create a link element to trigger the download
  const a = document.createElement("a");
  a.href = url;

  a.download = fileName; // Set the desired file name
  document.body.appendChild(a);

  // Trigger a click event on the link element to initiate the download
  a.click();

  // Clean up by revoking the blob URL and removing the link element
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
  sessionStorage.setItem("fileNameToDownload", "");
};

export const getSendMoneyErrorMessage = (destCurrency: string, sendingAmount: number) => {
  if (destCurrency === "USD") {
    if (sendingAmount <= 0 || sendingAmount < 5000 || sendingAmount === null) {
      return "The minimum you can send in one transaction is 5,000 INR";
    } else if (sendingAmount > 20000000) {
      return "The maximum you can send in one transaction is 2,00,00,000 INR";
    }
  } else {
    if (sendingAmount <= 0 || sendingAmount < 1000 || sendingAmount === null) {
      return "The minimum you can send in one transaction is 1,000 INR";
    } else if (sendingAmount > 20000000) {
      return "The maximum you can send in one transaction is 2,00,00,000 INR";
    }
  }
  return "";
};
export const getSendMoneyOfflineErrorMessage = () => {
  //sesnding
};

export const kycVerificationAgreementNote = (
  <div className="flex items-center">
    <div className="text-base font-bold text-grey-1200">
      Note :
      <span className="ml-1 text-base font-normal text-grey-1200">
        These documents play an important role in International money transfer so uploaded images
        should be clear and crisp or the chances of cancellation increase.
      </span>
    </div>
  </div>
);

export const kycDocsId = {
  E_VERIFY_VOTERID: 8,
  VERIFY_VOTERID_DOC: 12,
  E_VERIFY_DL: 5,
  VERIFY_DL_DOC: 10,
  E_VERIFY_PAN: 1,
  VERIFY_AADHAR_CARD: 2,
  UPLOAD_AADHAR_BACK: 16,
  PASSPORT_FRONT: 3,
  PASSPORT_BACK: 4,
};

export const additionalDocumentsList = [
  {
    name: "Overseas Education - University Fees",
    code: "Overseas-Education-University-Fees",
    longDisc: "Upload the following documents for confirming your universtiy fees",
    shortDisc: "Eg. Student Passport",
    isUploaded: false,
    uploadDoc: [
      {
        name: "Student Passport",
        code: "Student-Passport",
        isUploaded: false,
        uploadedId: 0,
        fileName: "",
        uploadedFile: "",
      },
    ],
  },
  {
    name: "Overseas Education - Living Expenses",
    code: "Overseas-Education-Living-Expenses",
    longDisc: "Upload the following documents for confirming your universtiy fees",
    shortDisc: "Eg. Student Passport",
    isUploaded: false,
    uploadDoc: [
      {
        name: "Student Passport",
        code: "Student-Passport",
        isUploaded: false,
        uploadedId: 0,
        fileName: "",
        uploadedFile: "",
      },
    ],
  },
  {
    name: "Family Maintenance",
    code: "Family-Maintenance",
    longDisc:
      "Upload the following documents for confirming your relationship with the beneficiary",
    shortDisc:
      "Choose any one of these Eg. Recepients Passport, PAN Card or other supporting document",
    isUploaded: false,
    uploadDoc: [
      {
        name: "Relationship Proof",
        code: "Relationship-Proof",
        isUploaded: false,
        uploadedId: 0,
        fileName: "",
        uploadedFile: "",
      },
    ],
  },
  {
    name: "Personal Gift or Donation",
    code: "Personal-Gift-Donation",
    longDisc: "Upload the following documents for confirming your recepient",
    shortDisc: "Eg. Recepient Passport, Driving License, SSN Number etc.",
    isUploaded: false,
    uploadDoc: [
      {
        name: "Recepient Passport",
        code: "Recepient-Passport",
        isUploaded: false,
        uploadedId: 0,
        fileName: "",
        uploadedFile: "",
      },
      {
        name: "Driving Licence / SSN number etc.",
        code: "Driving-Licence-SSN-number",
        isUploaded: false,
        uploadedId: 0,
        fileName: "",
        uploadedFile: "",
      },
    ],
  },
];

export const loanSanctionLetterDocData = {
  name: "Loan Sanction letter",
  code: "Loan-Sanction-letter",
  isUploaded: false,
  uploadedId: 0,
  fileName: "",
  uploadedFile: "",
};

export const stepperSteps: Array<string> = [
  "Amount",
  "Purpose and KYC Documents",
  "Recipients",
  "Review",
  "Send",
];

export const verifiedDocumentsData = [
  // { title: "CKYC", subtitle: "Verify CKYC", value: "CKYC" },
  { title: "Aadhaar Card", subtitle: "Verify Aadhaar Card", value: "AADHAR_CARD" },
  { title: "Driving License", subtitle: "Verify Driving License", value: "DRIVING_LICENCE" },
  { title: "Indian Passport", subtitle: "Verify Indian Passport", value: "PASSPORT_FRONT" },
];

export const purposeCodeList = [
  {
    value: "Overseas Education - University Fees",
    code: "S0305",
  },
  {
    value: "Overseas Education - Living Expenses",
    code: "S0305",
  },
  {
    value: "Family Maintenance",
    code: "S1301",
  },
  {
    value: "Personal Gift or Donation",
    code: "S1302",
  },
  // {
  //   value: "Medical Treatment Abroad",
  //   code: "S1108",
  // },
  // {
  //   value: "Private Visits",
  //   code: "S0306",
  // },
  // {
  //   value: "Business Travel",
  //   code: "S0301",
  // },
  // {
  //   value: "Emigration and Consultancy Fees",
  //   code: "S0306",
  // },
  // {
  //   value: "Employment and overseas job application fees",
  //   code: "S0306",
  // },
  // {
  //   value: "Educational tieup with Foreign Universities",
  //   code: "S1107",
  // },
  // {
  //   value: "Fees for examinations held in India or abroad for GRE, TOEFL etc.",
  //   code: "S0305",
  // },
];

export const getPurposeCode = async (name: any) => {
  for (const doc of additionalDocumentsList) {
    if (doc.name === name) {
      return doc.code;
    }
  }
  return null;
};

const startYear = 2021;
const currentYear = moment().year();
const yearList = [];
for (let year = startYear; year <= currentYear; year++) {
  yearList.push(year);
}

export const historyPageYearList = yearList.reverse();

export const receivingCountryData = [
  { countryName: "United States", currencyName: "USD" },
  { countryName: "Europe", currencyName: "EUR" },
  { countryName: "United Kingdom", currencyName: "GBP" },
  { countryName: "Canada", currencyName: "CAD" },
  { countryName: "Australia", currencyName: "AUD" },
  { countryName: "Singapore", currencyName: "SGD" },
  // { countryName: "Australia", currencyName: "AUD" },
  { countryName: "United Arab Emirates", currencyName: "AED" },
  // { countryName: "Mauritius", currencyName: "MUR" },
  { countryName: "Japan", currencyName: "JPY" },
  { countryName: "New Zeeland Dollars", currencyName: "NZD" },
  { countryName: "Swiss Franc", currencyName: "CHF" },
];

export const remitterTableHeaderData = [
  "Actions",
  "Remitter Name",
  "Remitter Email",
  "Remitter Mobile No",
  "KYC Status",
];

export const getKycStatusFromIdfy = (status: string) => {
  switch (status) {
    case "initiated":
      return "Inprogress";
    case "in_progress":
      return "Inprogress";
    case "processed":
      return "Inprogress";
    case "capture_pending":
      return "Inprogress";
    case "pending":
      return "Inprogress";
    case "recapture_pending":
      return "Inprogress";
    case "review_required":
      return "Inprogress";
    case "cancelled":
      return "Inprogress";
    case "failed":
      return "Inprogress";
    case "purged":
      return "Inprogress";
    case "completed":
      return "Yes";
    default:
      return "";
  }
};

export const isEmpty = (obj: any) => {
  for (const x in obj) {
    return false;
  }
  return true;
};

export const merge_object_arrays = (arr1: any, arr2: any, match: any) => {
  return _.union(
    _.map(arr1, function (obj1: any) {
      const same = _.find(arr2, function (obj2: any) {
        return obj1[match] === obj2[match];
      });
      return same ? _.extend(obj1, same) : obj1;
    }),
    _.reject(arr2, function (obj2: any) {
      return _.find(arr1, function (obj1: any) {
        return obj2[match] === obj1[match];
      });
    })
  );
};

export const currencySequence = [
  "USD",
  "CAD",
  "GBP",
  "EUR",
  "AUD",
  "AED",
  "JPY",
  "NZD",
  "SGD",
  "CHF",
  "MUR",
  "SAR",
];

export const relationships = [
  "Self",
  "Spouse",
  "Mother",
  "Father",
  "Son",
  "Daughter",
  "Brother",
  "Sister",
  "Son-in-law",
  "Daughter-in-law",
  "Others",
];

export const USERDETAILS_DATA = {
  salutation: [
    {
      value: "MR",
      label: "Mr",
    },
    {
      value: "MRS",
      label: "Mrs",
    },
    {
      value: "MS",
      label: "Ms",
    },
  ],
  incomeRange: [
    {
      value: "RANGE_0_TO_5L",
      label: "0 to 5 Lakh",
    },
    {
      value: "RANGE_5_TO_10L",
      label: "5 to 10 Lakh",
    },
    {
      value: "RANGE_10_TO_25L",
      label: "10 to 25 Lakh",
    },
    {
      value: "RANGE_25_TO_50L",
      label: "25 to 50 Lakh",
    },
    {
      value: "MORE_THAN_50L",
      label: "More than 50 Lakh",
    },
  ],
  residentStatus: [
    {
      value: "RESIDENT_INDIAN",
      label: "Resident Indian",
    },
    {
      value: "NON_RESIDENT_INDIAN",
      label: "Non-Resident Indian",
    },
    {
      value: "FOREIGNER_PERMANENTLY_RESIDING_IN_INDIA",
      label: "Foreigner Permanently Residing in India",
    },
    {
      value: "FOREIGNERS_TOURIST",
      label: "Foreigners - Tourist",
    },
    {
      value: "FOREIGNERS_RESIDENT",
      label: "Foreigners - Resident",
    },
  ],
  nationality: [
    {
      value: "INDIAN",
      label: "Indian National",
    },
    {
      value: "FOREIGN",
      label: "Foreign National",
    },
  ],
  gender: ["Male", "Female", "Others"],
  employmentStatus: ["Employed", "Self Employed", "Unemployed", "Student", "Retired"],
  fundSource: [
    "Salary Or Wages",
    "Student Loan",
    "Investments",
    "Personal Savings",
    "Personal Wealth",
    "Retirement Funds",
    "Business Owner/ShareHolder",
  ],
  industryType: [
    "Entertainment",
    "Agriculture",
    "Information Technology",
    "Legal",
    "Finance",
    "Business Consultancy",
    "Charity",
    "Computer - Hardware/software/electronics",
    "Education",
    "Food & Beverages",
    "Furniture & Flooring",
    "Manufacturing/Construction",
    "Insurance",
    "Marketing or Media",
    "Mining & Energy",
    "Chemical",
    "Online Gaming/ Betting",
    "Recruitment/Staffing",
    "Retail/Wholesale Trade",
    "Security",
    "Telecom",
    "Transportation",
    "Healthcare",
    "Textiles",
    "Others",
  ],
  states: [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttarakhand",
    "Uttar Pradesh",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Lakshadweep",
    "Puducherry",
  ],
};

export const countryOfResidence = [
  "United States",
  "United Kingdom",
  "Canada",
  "United Arab Emirates",
  "Singapore",
  "Australia",
  "Germany",
  "New Zealand",
  "France",
  "Italy",
  "Afghanistan",
  "Åland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "AndorrA",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, The Democratic Republic of the",
  "Cook Islands",
  "Costa Rica",
  "Cote D'Ivoire",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and Mcdonald Islands",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "Indonesia",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Republic of",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People'S Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libyan Arab Jamahiriya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia, The Former Yugoslav Republic of",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States of",
  "Moldova, Republic of",
  "Monaco",
  "Mongolia",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory, Occupied",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russia",
  "RWANDA",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia and Montenegro",
  "Seychelles",
  "Sierra Leone",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Taiwan, Province of China",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Viet Nam",
  "Virgin Islands, British",
  "Virgin Islands, U.S.",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const getCurrentIP = async () => {
  return await axios.get("https://geolocation-db.com/json/");
};

export const decryptData = (dataToEncrypt: string) => {
  if (!dataToEncrypt) {
    console.error("Invalid encrypted data provided.");
    return {};
  }
  try {
    const aes = new sjcl.cipher.aes(sjcl.codec.hex.toBits(Key));
    const decryptedData = sjcl.mode.ccm.decrypt(
      aes,
      sjcl.codec.hex.toBits(dataToEncrypt),
      sjcl.codec.hex.toBits("6d6f6e6579686f705f313233343536373839") // Convert IV to hex
    );
    const res = sjcl.codec.utf8String.fromBits(decryptedData);
    return res.trim().startsWith("{") || res.trim().startsWith("[") ? JSON.parse(res) : res;
  } catch (error) {
    console.error("Error in decryption", error);
    return {};
  }
};

export const encryptData = (dataToEncrypt: string) => {
  const aes = new sjcl.cipher.aes(sjcl.codec.hex.toBits(Key));
  const encryptedData: any = sjcl.mode.ccm.encrypt(
    aes,
    sjcl.codec.utf8String.toBits(dataToEncrypt),
    sjcl.codec.utf8String.toBits("moneyhop_123456789")
  );

  const res = sjcl.codec.hex.fromBits(encryptedData);
  return res;
};

export const lastTwoDecimal = (number: number) => {
  return Math.floor(number * 100) / 100;
};

export function formatNumber(number: any) {
  const formatter = new Intl.NumberFormat("en-IN");
  if (!isNaN(Number(number))) {
    return formatter.format(Number(number));
  }
}

export const formatIndianNumber = (num: string) => {
  if (!num) return "";
  const x = num.replace(/\D/g, "");
  const lastThree = x.slice(-3);
  const otherNumbers = x.slice(0, -3);
  return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + (otherNumbers ? "," : "") + lastThree;
};

export const purposeValEnhancer = (str: any) => {
  const blacklistWords = ["or"]; // Add more if needed

  return str
    ?.trim()
    ?.replace(/[^a-zA-Z0-9]+/g, "-") // Replace non-alphanumerics with hyphen
    ?.replace(/^-+|-+$/g, "") // Trim leading/trailing hyphens
    ?.replace(/-{2,}/g, "-") // Collapse multiple hyphens
    ?.split("-")
    ?.filter((word: string) => !blacklistWords.includes(word.toLowerCase())) // Remove 'or', 'and', etc.
    ?.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize
    ?.join("-");
};
